/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_None_LabelInputs */

const en_compare_event_groups_none_label = /** @type {(inputs: Compare_Event_Groups_None_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const fr_compare_event_groups_none_label = /** @type {(inputs: Compare_Event_Groups_None_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun`)
};

const de_compare_event_groups_none_label = /** @type {(inputs: Compare_Event_Groups_None_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keiner`)
};

const it_compare_event_groups_none_label = /** @type {(inputs: Compare_Event_Groups_None_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuno`)
};

const ru_compare_event_groups_none_label = /** @type {(inputs: Compare_Event_Groups_None_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Никто`)
};

const es_compare_event_groups_none_label = /** @type {(inputs: Compare_Event_Groups_None_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguno`)
};

const zh_cn2_compare_event_groups_none_label = /** @type {(inputs: Compare_Event_Groups_None_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有任何`)
};

const ja_compare_event_groups_none_label = /** @type {(inputs: Compare_Event_Groups_None_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なし`)
};

const hi_compare_event_groups_none_label = /** @type {(inputs: Compare_Event_Groups_None_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई नहीं`)
};

const pt_pt2_compare_event_groups_none_label = /** @type {(inputs: Compare_Event_Groups_None_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum`)
};

/**
* | output |
* | --- |
* | "None" |
*
* @param {Compare_Event_Groups_None_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_none_label = /** @type {((inputs?: Compare_Event_Groups_None_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_None_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_none_label(inputs)
	if (locale === "de") return de_compare_event_groups_none_label(inputs)
	if (locale === "it") return it_compare_event_groups_none_label(inputs)
	if (locale === "ru") return ru_compare_event_groups_none_label(inputs)
	if (locale === "es") return es_compare_event_groups_none_label(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_none_label(inputs)
	if (locale === "ja") return ja_compare_event_groups_none_label(inputs)
	if (locale === "hi") return hi_compare_event_groups_none_label(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_none_label(inputs)
	return en_compare_event_groups_none_label(inputs)
});